import { api } from './api';
import { Comunicado, ComunicadoFormatado } from 'types/comunicado';
import { dedupedFetch } from './cache';

export const buscarComunicados = async (): Promise<ComunicadoFormatado[]> => {
  return dedupedFetch("comunicados", async () => {
    const { data } = await api.get<Comunicado[]>('/database/comunicados__c');

    return data.map((comunicado) => ({
      id: comunicado._id,
      titulo: comunicado.title,
      descricao: '',
      steps: comunicado.steps
    }));
  }, 120_000);
};

export const buscarComunicadoPorId = async (id: string): Promise<ComunicadoFormatado | null> => {
  try {
    const { data } = await api.get<Comunicado>(`/database/comunicados__c/${id}`);
    
    return {
      id: data._id,
      titulo: data.title,
      descricao: '',
      steps: data.steps
    };
  } catch (error: any) {
    console.error('Erro ao buscar comunicado:', error);
    return null;
  }
};
